import React, { useState, useEffect } from 'react';
import img1 from '../../assets/images/yogesh logo.png';


import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { Link, useLocation } from 'react-router-dom';
import { IoCallSharp } from 'react-icons/io5';
import { HiMail } from 'react-icons/hi';


const Navbar = () => {
    // navbar scroll bg color change
    const [isSticky, setIsSticky] = useState(false);


    const handleScroll = () => {
        const scrollTop = window.scrollY;
        setIsSticky(scrollTop > 60);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // mobile menu toggle 
    const [nav, setNav] = useState(false)

    const handleNav = () => {
        setNav(!nav)
    }

    // select state
    const { pathname } = useLocation();

    return (
        <>
            <nav className='hidden md:flex gap-3 py-1 px-5 lg:px-10 text-sm font-medium text-white bg-gradient-to-r from-blue-800 to-blue-950 '>
                <button className='inline-flex items-center gap-1 hover:text-[#E66A22]'>
                    <IoCallSharp />
                    <Link to={'tel:9003383786'} >9003383786 </Link>
                </button>

                <button className='inline-flex items-center gap-1 hover:text-[#E66A22]'>
                    <HiMail />
                    <Link to={'mailto:admin@arnet.in'} >yogeshaluminium@gmail.com </Link>
                </button>
            </nav>
            <header className={`sticky top-0 z-50 left-0 w-full transition-colors duration-300 ${isSticky ? 'bg-[#fafdff] shadow-md' : 'bg-white'}`}>
                <div className=' px-3 md:px-5 py-2 flex justify-between w-full items-center '>
                    <Link to={'/'}>
                        <img src={img1} className=' h-12 md:h-16 object-cover ' alt="logo" />
                        
                    </Link>

                    {/* mobile menu */}

                    <div onClick={handleNav} className='lg:hidden'>
                        {nav ? <AiOutlineClose /> : <AiOutlineMenu className='text-lg'/>}
                    </div>

                    <div className={nav ? 'fixed  h-full w-2/3 md:w-[25%] shadow bg-white left-0 top-0 transform duration-300' : 'fixed left-[-100%] z-50 divide-y'}>
                        <div className=' flex px-3  py-2'>
                            <Link to={'/'} className='w-full  '>

                                <img src={img1} className=' lg:hidden flex justify-center  object-cover h-10' alt="logo" />
                                {/* <img src={img3} className=' lg:hidden flex justify-center  object-cover h-10' alt="logo" /> */}
                            </Link>
                        </div>

                        <ul className='capitalize flex w-full flex-col h-full gap-4 font-medium '>
                            <li className={`w-full hover:bg-[#182e55] hover:text-white text-gray-700 px-3 py-1.5`}><Link to={'/'} >home</Link></li>

                            <li className='w-full hover:bg-[#182e55] hover:text-white text-gray-700 px-3 py-1.5'><Link to={'/About'} >about us</Link></li>


                            <li className='w-full hover:bg-[#182e55] hover:text-white text-gray-700 px-3 py-1.5'><Link to={'/product'} >products</Link></li>

                            <li className='w-full hover:bg-[#182e55] hover:text-white text-gray-700 px-3 py-1.5'><Link to={'/safety'} >safety and security</Link></li>

                            <li className='w-full hover:bg-[#182e55] hover:text-white text-gray-700 px-3 py-1.5'><Link to={'/contact'} >contact us</Link></li>

                            

                        </ul>
                    </div>

                    {/* Desktop menu */}

                    <nav className='hidden lg:block'>
                        <ul className='capitalize font-medium flex gap-8 '>
                            <li><Link to={'/'} className={`${pathname == "/" ? "text-[#E66A22] border-b-2 border-[#E66A22]" : ""}  hover:text-[#142a4e] hover:border-b-2 hover:border-[#142a4e] transition-transform duration-200 py-1`}>home</Link></li>

                            <li><Link to={'/about'} className={`${pathname == "/about" ? "text-[#E66A22] border-b-2 border-[#E66A22]" : ""}  hover:text-[#142a4e] hover:border-b-2 hover:border-[#142a4e] transition-transform duration-200 py-1`}>about us</Link></li>

                            

                            <li><Link to={'/product'} className={`${pathname == "/product" ? "text-[#E66A22] border-b-2 border-[#E66A22]" : ""}  hover:text-[#142a4e] hover:border-b-2 hover:border-[#142a4e] transition-transform duration-200 py-1`}>Products</Link></li>

                            <li><Link to={'/safety'} className={`${pathname == "/safety" ? "text-[#E66A22] border-b-2 border-[#E66A22]" : ""}  hover:text-[#142a4e] hover:border-b-2 hover:border-[#142a4e] transition-transform duration-200 py-1`}>Safety and Security</Link></li>

                        </ul>
                    </nav>

                    <Link to={'/contact'} className='hidden lg:block'>
                        <button className=' bg-[#142a4e] hover:text-[#142a4e] border-2 hover:bg-white  hover:border-[#182e55] border-[#142a4e] text-[#ffffff] px-5 py-2 rounded-md font-semibold'>Get in Touch</button></Link>
                </div>
            </header>


        </>
    );
};

export default Navbar;


